import { useState } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import { Toast } from 'primereact/toast';
const PartnershopsListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/partnershops/view/${data.id}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('partnershops/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/partnershops/edit/${data.id}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('partnershops/edit')
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.id) },
			icon: "pi pi-trash",
			visible: () => auth.canView('partnershops/delete')
		},
		{
			label: "Update Lat/Lon",
			command: (event) => { app.navigate(`/partnershops/view/${data.id}`) },
			icon: "pi pi-globe",
			visible: () => auth.canView('partnershops/view')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function IdTemplate(data){
		if(data){
			return (
				<Link to={`/partnershops/view/${data.id}`}> { data.id }</Link>
			);
		}
	}
	function ContactphoneTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`tel:${data.contactphone}`}>{ data.contactphone }</a>
			);
		}
	}
	function ContactemailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.contactemail}`}>{ data.contactemail }</a>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Delete Selected"/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-partnershops`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="" tooltip="Export" buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="partnershops/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
function ActionButton(data) {
    const [loading, setLoading] = useState(false);
    const API_URL = process.env.REACT_APP_API_PATH;
    const updateLatLon = async () => {
        try {
            setLoading(true);
            // Prepare the request data
            // Call the bulk-geocode API endpoint
        const response = await fetch(`${API_URL}geocode/update-single`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
            shopId: parseInt(data.id), 
          forceUpdate: false 
        }),
      });
        const result = await response.json();
        if (response.ok && result.successCount > 0) {
            // Show success message
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: `Latitude/Longitude updated for ${data.shopcode}`,
                life: 3000
            });
            // Refresh the data grid or update local state
            if (window.refreshGrid) {
                window.refreshGrid();
                } else {
                // Alternative: trigger a custom event
                window.dispatchEvent(new CustomEvent('refreshGrid'));
            }
            } else {
            // Show error message
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: result.results?.[0]?.error || 'Failed to update coordinates',
                life: 3000
            });
        }
        } catch (error) {
        console.error('Error updating lat/lon:', error);
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update coordinates',
            life: 3000
        });
        } finally {
        setLoading(false);
    }
};
const items = [
{
    label: "View",
    command: (event) => { app.navigate(`/partnershops/view/${data.id}`) },
    icon: "pi pi-eye",
    visible: () => auth.canView('partnershops/view')
},
{
    label: "Edit",
    command: (event) => { app.navigate(`/partnershops/edit/${data.id}`) },
    icon: "pi pi-pencil",
    visible: () => auth.canView('partnershops/edit')
},
{
    label: "Delete",
    command: (event) => { deleteItem(data.id) },
    icon: "pi pi-trash",
    visible: () => auth.canView('partnershops/delete')
},
{
    label: "Update Lat/Lon",
    command: (event) => { updateLatLon() },
    icon: "pi pi-globe",
    visible: () => auth.canView('partnershops/view')
}
].filter((item) => {
    if (item.visible) {
        return item.visible();
    }
    return true;
});
return (
<SplitButton 
dropdownIcon="pi pi-bars" 
className="dropdown-only p-button-text p-button-plain" 
model={items} 
loading={loading}
/>
);
}
	return (
<main id="PartnershopsListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Partnershops"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/partnershops/add`}>
                        <Button label="Add New Partnershop" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="id" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="id" header="Id" body={IdTemplate}  ></Column>
                                    <Column  field="shopcode" header="Shopcode"   ></Column>
                                    <Column  field="shopname" header="Shopname"   ></Column>
                                    <Column  field="ownername" header="Ownername"   ></Column>
                                    <Column  field="contactphone" header="Contactphone" body={ContactphoneTemplate}  ></Column>
                                    <Column  field="contactemail" header="Contactemail" body={ContactemailTemplate}  ></Column>
                                    <Column  field="address" header="Address"   ></Column>
                                    <Column  field="city" header="City"   ></Column>
                                    <Column  field="state" header="State"   ></Column>
                                    <Column  field="zipcode" header="Zipcode"   ></Column>
                                    <Column  field="latitude" header="Latitude"   ></Column>
                                    <Column  field="longitude" header="Longitude"   ></Column>
                                    <Column  field="shoptype" header="Shoptype"   ></Column>
                                    <Column  field="status" header="Status"   ></Column>
                                    <Column  field="commissionrate" header="Commissionrate"   ></Column>
                                    <Column  field="serviceradius" header="Serviceradius"   ></Column>
                                    <Column  field="operatinghours" header="Operatinghours"   ></Column>
                                    <Column  field="capacityperday" header="Capacityperday"   ></Column>
                                    <Column  field="currentload" header="Currentload"   ></Column>
                                    <Column  field="rating" header="Rating"   ></Column>
                                    <Column  field="totalreviews" header="Totalreviews"   ></Column>
                                    <Column  field="isverified" header="Isverified"   ></Column>
                                    <Column  field="verificationdate" header="Verificationdate"   ></Column>
                                    <Column  field="registrationdate" header="Registrationdate"   ></Column>
                                    <Column  field="lastactive" header="Lastactive"   ></Column>
                                    <Column  field="notes" header="Notes"   ></Column>
                                    <Column  field="date_created" header="Date Created"   ></Column>
                                    <Column  field="date_updated" header="Date Updated"   ></Column>
                                    <Column  field="userid" header="Userid"   ></Column>
                                    <Column  field="min_order_amt" header="Min Order Amt"   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
PartnershopsListPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'partnershops',
	apiPath: 'partnershops/index',
	routeName: 'partnershopslist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default PartnershopsListPage;
